import { observer } from 'mobx-react-lite'
import { type ChangeEvent, useEffect, useRef, useState } from 'react'
import { Box, Button, Typography } from 'shared/ui'
import { useReviewViewContext } from 'pages/reviews/context'
import { PreviewLogo } from 'pages/reviews/ui/Preview/PreviewLogo'
import styles from './styles.module.scss'

export const PreviewUnhappy = observer(() => {
  const [showSuccess, setShowSuccess] = useState(false)
  const [value, setValue] = useState('')
  const { title, unhappySubtitle, setActiveTab } = useReviewViewContext()
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const textareaHandler = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const trimmedValue = e.target.value.slice(0, 120)

    setValue(trimmedValue)
  }
  const handleSubmit = () => {
    setShowSuccess(true)

    timerRef.current = setTimeout(() => {
      setActiveTab('appearance')
    }, 6000)
  }

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  if (showSuccess)
    return (
      <Box
        display={'flex'}
        justifyContent={'center'}
        flexDirection={'column'}
        padding={'48px 16px 16px'}
      >
        <PreviewLogo />
        <Box padding={'0 24px'} display={'flex'} flexDirection={'column'}>
          <Typography ariaLabel={'reviewTitle'} className={styles.title} marginBottom={7}>
            {'Thank you'}
          </Typography>
        </Box>
      </Box>
    )

  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      flexDirection={'column'}
      padding={'48px 16px 16px'}
    >
      <PreviewLogo />
      <Box padding={'0 24px'} display={'flex'} flexDirection={'column'}>
        <Typography ariaLabel={'reviewTitle'} className={styles.title} marginBottom={7}>
          {title || 'Title'}
        </Typography>
        <Typography
          ariaLabel={'reviewSubtitle'}
          variant={'body-rg-medium'}
          className={styles.subtitle}
          marginBottom={32}
        >
          {unhappySubtitle || 'Subtitle'}
        </Typography>
      </Box>
      <div className={styles.textareaWrap}>
        <textarea
          value={value}
          onChange={textareaHandler}
          placeholder={'Tell us more'}
          className={styles.textarea}
        />
        <Box paddingTop={'14px'}>
          <Button
            text='Submit'
            size='medium'
            fullWidth
            disableHover
            className={styles.submitBtn}
            onClick={handleSubmit}
          />
        </Box>
      </div>
    </Box>
  )
})
